<template>
    <div v-resize="onResize">
        <div id="sunburst-content">
            <div id="sunburst-d3">##&en Loading ... ##&hu Betöltés ... ##</div>
        </div>
        <v-bottom-navigation fixed background-color="primary">
            <v-btn class="mx-2" fab dark color="primary" @click="refresh()"><v-icon dark> mdi-refresh </v-icon></v-btn>
        </v-bottom-navigation>
    </div>
</template>
<script>
import define from "@/diagram-components/sunburst.d3.js";

export default {
    name: "diagram-sunburst",
    props: ["id"],
    data: function () {
        return {
            sunburst_d3: null,
            width: window.innerWidth,
            height: window.innerHeight,
        };
    },
    mounted() {
        // wait for server side run functions to complete
        setTimeout(() => {
            this.sunburst_d3 = define(this);
        }, 1000);
    },
    methods: {
        refresh() {
            this.sunburst_d3 = define(this);
        },
        onResize() {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
            //Ł(this.databaseschema_d3);
            if (this.sunburst_d3) this.sunburst_d3.setViewBox();
        },
    },
};
</script>
<style scoped>
.display-text {
}
.display-container {
    cursor: pointer;
}
</style>
